<template>
  <section class="page-banner" :class="{ 'page-banner--compact': compact }">
    <div class="page-banner__cloud cn-cloud-pattern" aria-hidden="true" />
    <div class="page-banner__corner page-banner__corner--tl" aria-hidden="true" />
    <div class="page-banner__corner page-banner__corner--tr" aria-hidden="true" />
    <div class="page-banner__inner">
      <p v-if="eyebrow" class="page-banner__eyebrow">{{ eyebrow }}</p>
      <h1>
        <span class="page-banner__mark" aria-hidden="true">◈</span>
        {{ title }}
        <span class="page-banner__mark" aria-hidden="true">◈</span>
      </h1>
      <chinese-divider light />
      <p v-if="subtitle" class="page-banner__subtitle">{{ subtitle }}</p>
    </div>
    <svg class="page-banner__wave" viewBox="0 0 1200 48" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,24 C200,48 400,0 600,24 C800,48 1000,0 1200,24 L1200,48 L0,48 Z" fill="rgba(247,248,250,0.15)" />
      <path d="M0,32 C300,8 500,40 800,20 C1000,8 1100,36 1200,28 L1200,48 L0,48 Z" fill="rgba(255,255,255,0.06)" />
    </svg>
  </section>
</template>

<script>
import ChineseDivider from '@/components/ChineseDivider.vue';

export default {
  name: 'PageBanner',
  components: { ChineseDivider },

  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: '' },
    eyebrow: { type: String, default: '' },
    compact: { type: Boolean, default: false }
  }
};
</script>

<style scoped>
.page-banner {
  width: 100%;
  background: linear-gradient(135deg, #6b1228 0%, #a81830 45%, #c41e3a 100%);
  color: #fff;
  padding: 56px 24px;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
}
.page-banner::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 20% 80%, rgba(255, 215, 120, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(255, 255, 255, 0.08) 0%, transparent 40%);
  pointer-events: none;
}
.page-banner__cloud {
  position: absolute;
  inset: 0;
  opacity: 0.55;
  pointer-events: none;
}
.page-banner__corner {
  position: absolute;
  width: 56px;
  height: 56px;
  border: 1px solid rgba(212, 160, 74, 0.35);
  pointer-events: none;
}
.page-banner__corner--tl {
  top: 16px;
  left: 24px;
  border-right: none;
  border-bottom: none;
}
.page-banner__corner--tr {
  top: 16px;
  right: 24px;
  border-left: none;
  border-bottom: none;
}
.page-banner__mark {
  font-size: 0.55em;
  color: rgba(232, 200, 120, 0.9);
  margin: 0 10px;
  vertical-align: middle;
}
.page-banner__wave {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 48px;
  pointer-events: none;
}
.page-banner--compact {
  padding: 40px 24px;
}
.page-banner__inner {
  position: relative;
  max-width: 800px;
  margin: 0 auto;
}
.page-banner__eyebrow {
  margin: 0 0 10px;
  font-size: 13px;
  letter-spacing: 4px;
  opacity: 0.85;
  text-transform: uppercase;
}
.page-banner h1 {
  margin: 0 0 4px;
  font-size: 32px;
  font-weight: 700;
  letter-spacing: 6px;
}
.page-banner__subtitle {
  margin: 4px 0 0;
  font-size: 15px;
  line-height: 1.7;
  opacity: 0.9;
}
</style>
